document.addEventListener('click', function (e) {
  var minusBtn = e.target.closest('.cart__mini-qty--minus');
  var removeBtn = e.target.closest('.remove-from-cart');

  if (!minusBtn && !removeBtn) return;

  var row = (minusBtn || removeBtn).closest('.ajaxcart__product');
  if (!row) return;

  var input = row.querySelector('.cart__mini-qty--input');
  var currentQty = input ? parseInt(input.value, 10) : null;

  // Sirf intercept karo jab: remove icon directly click hua, YA minus click hua aur qty 1 hai
  var shouldRemove = removeBtn || (minusBtn && currentQty === 1);
  if (!shouldRemove) return;

  e.preventDefault();
  e.stopPropagation(); // nuranium.js ke purane delegated handlers ko chalne se roko

  // variant id se identify karo, line number se nahi - kyunki JS-built minicart mein
  // data-line 0-indexed hota hai jabki Shopify API 1-indexed line expect karta hai (422 error)
  var variantId = (removeBtn && removeBtn.dataset.productId) ||
                   (input && input.dataset.id);

  if (!variantId) {
    console.error('Cart quick-remove: variant id nahi mila', row);
    return;
  }

  // turant visual feedback - user ko lagega instant hua
  row.style.transition = 'opacity 0.2s, max-height 0.3s';
  row.style.opacity = '0.3';
  row.style.pointerEvents = 'none';

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 })
  })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      // row ko poori tarah hata do
      row.style.maxHeight = '0px';
      row.style.overflow = 'hidden';
      setTimeout(function () { row.remove(); }, 300);

      // count/subtotal khud update karo - theme ke buggy Currency.convertAll call par depend nahi karna
      var moneyFormat = (window.theme && window.theme.moneyFormat) || '₹{{amount}}';
      var formattedTotal = (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cart.total_price, moneyFormat)
        : '₹' + (cart.total_price / 100).toFixed(2);

      document.querySelectorAll('#CartCount, #CartCountCavas').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      var cartTotalEl = document.getElementById('cart_total');
      if (cartTotalEl) cartTotalEl.innerHTML = formattedTotal;
      document.querySelectorAll('#cart-info .subtotal span').forEach(function (el) {
        el.innerHTML = formattedTotal;
      });

      // cart khali ho gaya to hi poora drawer rebuild karo (empty-state dikhane ke liye)
      if (cart.item_count === 0 && window.nuranium) {
        try {
          nuranium.initMiniCart();
        } catch (err) {
          console.warn('initMiniCart warning (Currency.convertAll bug, ignorable):', err);
        }
      }
    })
    .catch(function (err) {
      console.error('Mini cart remove failed:', err);
      row.style.opacity = '1';
      row.style.pointerEvents = 'auto';
    });
}, true); // capture: true zaroori hai taake yeh nuranium.js ke handlers se pehle chale